/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { inheritsLoose as _inheritsLoose, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { z } from 'zod';
import { ValidationFailedError } from '../errors.js';
import { OperationHelpers } from './constants.js';
import { BaseOperator } from './helpers.js';

var AmlCheckV2 = /*#__PURE__*/function (_BaseOperator) {
  function AmlCheckV2() {
    var _this;
    _this = _BaseOperator.call(this, {
      operator: 'AML_CHECK_V2'
    }) || this;
    _this.evaluate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dataValue, conditionValue) {
        var amlOperator, evaluateOperatorCheck;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              amlOperator = OperationHelpers[conditionValue.operator];
              evaluateOperatorCheck = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
                  var _amlOperator$dataValu, _amlOperator$conditio;
                  var result, conditionResult;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        result = (_amlOperator$dataValu = amlOperator.dataValueSchema) == null ? void 0 : _amlOperator$dataValu.safeParse(data);
                        if (!(result && !result.success)) {
                          _context.next = 3;
                          break;
                        }
                        return _context.abrupt("return", false);
                      case 3:
                        conditionResult = (_amlOperator$conditio = amlOperator.conditionValueSchema) == null ? void 0 : _amlOperator$conditio.safeParse(conditionValue.value);
                        if (!(conditionResult && !conditionResult.success || !(conditionResult != null && conditionResult.data))) {
                          _context.next = 6;
                          break;
                        }
                        return _context.abrupt("return", false);
                      case 6:
                        _context.next = 8;
                        return amlOperator.execute(data, conditionResult.data);
                      case 8:
                        return _context.abrupt("return", _context.sent);
                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function evaluateOperatorCheck(_x3) {
                  return _ref2.apply(this, arguments);
                };
              }();
              if (!(dataValue && Array.isArray(dataValue))) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", dataValue.some(evaluateOperatorCheck));
            case 6:
              return _context2.abrupt("return", evaluateOperatorCheck(dataValue));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    return _this;
  }
  _inheritsLoose(AmlCheckV2, _BaseOperator);
  var _proto = AmlCheckV2.prototype;
  _proto.extractValue = /*#__PURE__*/function () {
    var _extractValue = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data, rule, _ref3) {
      var _context$entity$data$, _context$entity, _context$entity$data, _context$entity$data$2, _context$entity$data$3, _context$entity$data$4, _context$entity2, _context$entity2$data, _context$entity2$data2, _context$entity2$data3, _context$entity3, _context$entity3$data, _context$entity3$data2, _context$entity3$data3;
      var helpers, result, context, ubosIds, directorsIds, mainRepresentativeEndUserId, endUserIds, endUsers, hits, variable;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            helpers = _ref3.helpers;
            result = z.record(z.string(), z.any()).safeParse(data);
            if (result.success) {
              _context3.next = 4;
              break;
            }
            throw new ValidationFailedError('extract', 'parsing failed', result.error);
          case 4:
            context = result.data;
            ubosIds = (_context$entity$data$ = context == null ? void 0 : (_context$entity = context.entity) == null ? void 0 : (_context$entity$data = _context$entity.data) == null ? void 0 : (_context$entity$data$2 = _context$entity$data.additionalInfo) == null ? void 0 : (_context$entity$data$3 = _context$entity$data$2.ubos) == null ? void 0 : _context$entity$data$3.map(function (ubo) {
              return ubo.ballerineEntityId;
            })) != null ? _context$entity$data$ : [];
            directorsIds = (_context$entity$data$4 = context == null ? void 0 : (_context$entity2 = context.entity) == null ? void 0 : (_context$entity2$data = _context$entity2.data) == null ? void 0 : (_context$entity2$data2 = _context$entity2$data.additionalInfo) == null ? void 0 : (_context$entity2$data3 = _context$entity2$data2.directors) == null ? void 0 : _context$entity2$data3.map(function (director) {
              return director.ballerineEntityId;
            })) != null ? _context$entity$data$4 : [];
            mainRepresentativeEndUserId = context == null ? void 0 : (_context$entity3 = context.entity) == null ? void 0 : (_context$entity3$data = _context$entity3.data) == null ? void 0 : (_context$entity3$data2 = _context$entity3$data.additionalInfo) == null ? void 0 : (_context$entity3$data3 = _context$entity3$data2.mainRepresentative) == null ? void 0 : _context$entity3$data3.ballerineEntityId;
            endUserIds = [].concat(ubosIds, directorsIds, [mainRepresentativeEndUserId]);
            if (!isEmpty(endUserIds)) {
              _context3.next = 11;
              break;
            }
            return _context3.abrupt("return", false);
          case 11:
            _context3.next = 13;
            return Promise.all(endUserIds.filter(Boolean).map(function (endUserId) {
              return helpers.getEndUserById(endUserId);
            }));
          case 13:
            endUsers = _context3.sent;
            if (!isEmpty(endUsers)) {
              _context3.next = 16;
              break;
            }
            throw new ValidationFailedError('extract', "End Users not found: " + endUserIds.join(', '));
          case 16:
            // TODO: In the future, AML data will not be in the endUser object
            hits = endUsers.map(function (endUser) {
              return endUser.amlHits;
            }).flat(1).filter(Boolean);
            if (!(!Array.isArray(hits) || hits.length === 0)) {
              _context3.next = 19;
              break;
            }
            return _context3.abrupt("return", false);
          case 19:
            variable = hits.map(function (hit) {
              return get(hit, rule.key);
            }).filter(Boolean);
            return _context3.abrupt("return", variable);
          case 21:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function extractValue(_x4, _x5, _x6) {
      return _extractValue.apply(this, arguments);
    }
    return extractValue;
  }();
  return AmlCheckV2;
}(BaseOperator);
var AML_CHECK_V2 = new AmlCheckV2();

export { AML_CHECK_V2 };
//# sourceMappingURL=aml-v2-check.js.map
